// extracted by mini-css-extract-plugin
export var arrow = "HomePage-module--arrow--gIvr0";
export var doubleImageWrap = "HomePage-module--doubleImageWrap--JiYB-";
export var fullImage = "HomePage-module--fullImage--R3MhN";
export var fullText = "HomePage-module--fullText--LZ-4x";
export var shopLinkBtn = "HomePage-module--shopLinkBtn--3m6yd";
export var singleImageWrap = "HomePage-module--singleImageWrap--MXkU2";
export var twinImages = "HomePage-module--twinImages--unF9c";
export var windowText = "HomePage-module--windowText--paW7b";